<td #td class="≈relative ≈px-4 ≈py-3">
    <div class="≈overflow-hidden ≈overflow-ellipsis">
        <ng-content>

        </ng-content>
    </div>
</td>
